module.exports = __webpack_public_path__ + "static/media/wechat.6a1a2d37.png";